module.exports = __webpack_public_path__ + "static/img/role.fd24a5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/kr/role.png
// module id = HClF
// module chunks = 7